import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import { optionPropTypes } from 'sharedParts/config/blockConfig/settings/optionListPropTypes';

import MatrixCell from '../../layout/MatrixCell';
import MatrixInputGroup from '../MatrixInputGroup';
import MatrixRatingInput from '../MatrixRatingInput';
import propTypeBlockStyling from '../../../../../../domains/styling/config/editorBlock/PropTypes/blockStyling';

export default class MatrixScaleGroupField extends Component {
  static propTypes = {
    block: optionPropTypes,
    option: optionPropTypes,
    input: PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.object,
      onChange: PropTypes.func.isRequired,
    }).isRequired,
    shape: PropTypes.string.isRequired,
    meta: PropTypes.object.isRequired,
    labelList: PropTypes.array,
    itemListCount: PropTypes.number,
    hasAnswer: PropTypes.bool,
    form: PropTypes.string.isRequired,
    styling: propTypeBlockStyling,
  };

  handleChange = selectedValue => {
    this.props.input.onChange({
      selectedValue,
      option: this.props.option.value,
    });
  };

  render() {
    const {
      input,
      meta,
      option,
      labelList,
      shape,
      itemListCount,
      hasAnswer,
      form,
      styling,
      block,
    } = this.props;

    return (
      <MatrixInputGroup
        form={form}
        meta={meta}
        option={option}
        styling={styling}
      >
        <MatrixCell
          hasInput
          colSpan={labelList.length}
          labelList={labelList}
          cellRenderer={MatrixRatingInput}
          block={block} // passing `block` to respect getRenderedScaleIcons signature @sinslav
          onChange={this.handleChange}
          value={get(input.value, 'selectedValue')}
          shape={shape}
          hasAnswer={hasAnswer}
          meta={meta}
          itemListCount={itemListCount}
          styling={styling}
        />
      </MatrixInputGroup>
    );
  }
}
